module.exports = __webpack_public_path__ + "static/media/object_immotal.57997353.png";